import RingLoader from '../components/RingLoader'

export default function RingLoaderTest(){
  return (
    <main style={{ width:'100vw', height:'100vh' }}>
      <RingLoader />
    </main>
  )
}

